import React, { useEffect } from "react";
import MdaeTextBox from "../../../common_components/common_widgets/text-box";
import MdaeDateBox from "../../../common_components/common_widgets/date-box";
import MdaeTextArea from "../../../common_components/common_widgets/text-area";
import { Validator } from "devextreme-react";
import {  RequiredRule } from "devextreme-react/validator";
import { callOperation, actions } from "async-ops";
import MdaeSelectBox from "../../../common_components/common_widgets/select-box";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../../common_components/common_widgets/popup";
import MdaeButton from "../../../common_components/common_widgets/button";
import {  
  formatDenialReasonsObjectToDisplay,
  formatDenialReasonsObjectToSave,
  RESET_DENIAL_REASONS_POPUP_VALIDATION,
  SET_DENIAL_REASONS_END_DATE,
  SET_DENIAL_REASONS_FORM_DATA,
  SET_DENIAL_REASON_AFFECTING_FIELDS_CHANGE_OBJECT,
  TOGGLE_ADD_DENIAL_REASONS_POPUP,
  TOGGLE_DENIAL_REASONS_WARNING_POPUP,
} from "../denial-reasons/reducers/denial-reasons-reducer";
import { useSelector, useDispatch } from "react-redux";
import { GET_DENIAL_REASONS_REFERENCE_DATA } from "./services/get-reference-data";
import { isEqual } from "lodash";
import { differenceInCalendarDays, format } from "date-fns";
import MdaeTagBox from "../../../common_components/common_widgets/tag-box";
import { GET_DENIAL_REASONS_AUDIT_GROUP_LIST } from "./services/get-audit-group-list";

import {
  DENIAL_REASONS_POPUP_MODE,
  DENIAL_REASONS_WARNING_POPUP_MODE,
  toggleDenialReasonsPopup,
} from "./component";
import { SAVE_DENIAL_REASONS } from "./services/save-denial-reasons";
import compareAsc from "date-fns/compare_asc/index.js";
import {
  HIDE_LOADER,
  SHOW_LOADER,
} from "../../../common_components/mdae-common-reducer";
import { GET_DENIAL_REASONS_BY_ID } from "./services/get-denial-reasons-by-id";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../../common_components/common_widgets/toast/notify";
import { GET_DENIAL_REASONS_LIST } from "./services/get-denial-reasons-list";
import DenialReasonsWarningPopup from "./denial-reasons-warning-popup";
import { getUserPermissionObject } from "../../../common_components/user-permissions-helper";
import { GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP } from "../../user-management/external-users/services/get-active-external-user-list-for-user-group";
import { GET_TARGET_VALUE_LOOKUP } from "../../external-audit/services/get-taregt-values";
export const openDenialReasonsInEditMode = (
  currentSelectedRowData,
  toggleDenialReasonsPopup,
  dispatch
) => {
  toggleDenialReasonsPopup(
    dispatch,
    true,
    "Edit Denial Reason - " + currentSelectedRowData.denialReasonName,
    DENIAL_REASONS_POPUP_MODE.EDIT
  );
  dispatch({ type: SHOW_LOADER });
  callOperation(GET_DENIAL_REASONS_BY_ID, {
    denialReasonId: currentSelectedRowData.denialReasonId,
  }).then(function(response) {
    let updatedResponseObj = response;
    if (response?.isDenialReasonsAssignedToExternalUser) {
      updatedResponseObj = {
        ...updatedResponseObj,
        assignedToUserTypeValue: response.assignedToUserId,
      };
    }
    dispatch({
      type: SET_DENIAL_REASONS_FORM_DATA,
      data: {
        denialReasonsFormData: updatedResponseObj,
        initialDenialReasonsFormData: updatedResponseObj,
      },
    });
    dispatch({ type: HIDE_LOADER });
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("resize", { detail: { isResizeMdaePopup: true } })
      );
    }, 0);
  });
};
interface IAddDenialReasonsPopup {
  isHideSaveButton?: boolean;
}
const AddDenialReasonsPopup: React.FC<IAddDenialReasonsPopup> = (props) => {
  const dispatch = useDispatch();
  const denialReasonsValidationGroup = "denialReasonsValidationGroup";
  let denialReasonsFormData = useSelector(
    (state: any) => state.denialReasons.denialReasonsFormData,
    isEqual
  );
  const initialDenialReasonsFormData = useSelector(
    (state: any) => state.denialReasons.initialDenialReasonsFormData,
    isEqual
  );
  const workflowModuleTypeEnums = useSelector(
    (state: any) => state.denialReasons.workflowModuleTypeEnums,
    isEqual
  );
  const assignedToEnums = useSelector(
    (state: any) => state.denialReasons.assignedToEnums,
    isEqual
  ); 
  const auditGroupDataSourceList = useSelector(
    (state: any) => state.denialReasons.auditGroupDataSourceList,
    isEqual
  ); 
  const denialReasonsPopupMode = useSelector(
    (state: any) => state.denialReasons.denialReasonsPopupMode,
    isEqual
  );
  const denialReasonsLinkedData: any = useSelector(
    (state: any) => state.denialReasons.denialReasonsLinkedData,
    isEqual
  );
  const isModuleTypeDisabled: any = useSelector(
    (state: any) => state.denialReasons.isModuleTypeDisabled,
    isEqual
  );
  const isLevelValueDisabled: any = useSelector(
    (state: any) => state.denialReasons.isLevelValueDisabled,
    isEqual
  );
  const hasAllAuditGroupAccess = useSelector(
    (state: any) => state.denialReasons.hasAllAuditGroupAccess,
    isEqual
  );
  const denialReasonAffectingFieldsChangeTrackerObject: any = useSelector(
    (state: any) =>
      state.denialReasons.denialReasonAffectingFieldsChangeTrackerObject,
    isEqual
  );

  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const denialReasonsPermissions = getUserPermissionObject(
    "DENIAL_REASONS",
    currentUser
  );
  const isSelectExternalUserPopupVisible = useSelector(
    (state: any) => state.userTaskListReducer.isSelectExternalUserPopupVisible,
    isEqual
  );
  const externalUserList = useSelector(
    (state: any) =>
      state.externalUsersReducer.externalUserListForExternalUserGroup,
    isEqual
  );
  const assignedToUserTypeList = useSelector(
    (state: any) => state.denialReasons.assignedToUserTypeList,
    isEqual
  );
  const activeUserList = useSelector(
    (state: any) => state.denialReasons.activeUserList,
    isEqual
  );
  const requesterList = useSelector(
    (state) => state["auditPropertiesReducer"].requesterData,
    isEqual
  );
  const auditPropertiesDataAuditGroupId = useSelector(
    (state: any) => state.auditPropertiesReducer.auditPropertiesData.auditGroupId ? state.auditPropertiesReducer.auditPropertiesData.auditGroupId:0,
    isEqual
  );
  if (denialReasonsPopupMode === DENIAL_REASONS_POPUP_MODE.EDIT) {
    denialReasonsFormData = formatDenialReasonsObjectToDisplay(
      denialReasonsFormData,
      auditGroupDataSourceList
    );
  }
  const selectAllAuditGroup = () => {
    dispatch({
      type: SET_DENIAL_REASONS_FORM_DATA,
      data: {
        denialReasonsFormData: {
          selectedAuditGroupIds: auditGroupDataSourceList.map(
            (x) => x.auditGroupId
          ),
        },
      },
    });
  };
  useEffect(() => {
    dispatch(actions.asyncOperationStart(GET_DENIAL_REASONS_LIST, {}));
    dispatch(
      actions.asyncOperationStart(GET_DENIAL_REASONS_AUDIT_GROUP_LIST, {})
    );
    dispatch(
      actions.asyncOperationStart(GET_DENIAL_REASONS_REFERENCE_DATA, {})
    );
    dispatch(
      actions.asyncOperationStart(
        GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP,
        {}
      )
    );
  }, []);
  const saveDenialReasonsData = (isClosePopup) => {
    dispatch({ type: SHOW_LOADER });
    const dataToSave = formatDenialReasonsObjectToSave(
      denialReasonsFormData,
      auditGroupDataSourceList,
      assignedToEnums,
      workflowModuleTypeEnums,
      hasAllAuditGroupAccess
    );
    callOperation(SAVE_DENIAL_REASONS, dataToSave).then(function(response) {
      dispatch({ type: HIDE_LOADER });
      if (response.isSaved) {
        dispatch(actions.asyncOperationStart(GET_DENIAL_REASONS_LIST, {}));
        dispatch(
          actions.asyncOperationStart(GET_TARGET_VALUE_LOOKUP, {
            CodeType: "DENIAL_REASONS",
            EffectiveDate: new Date(),
            GroupId:auditPropertiesDataAuditGroupId
          })
        );
        mdaeNotify({
          message:
            denialReasonsFormData.denialReasonName +
            " - Denial Reason saved successfully.",
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
        if (!isClosePopup) {
          openDenialReasonsInEditMode(
            {
              denialReasonName: denialReasonsFormData.denialReasonName,
              denialReasonId: response.denialReasonId,
            },
            toggleDenialReasonsPopup,
            dispatch
          );
        }
      } else {
        mdaeNotify({
          message: "Unable to save denial reason",
          messageType: NOTIFY_MESSAGE_TYPE.ERROR,
        });
      }
      if (isClosePopup) toggleDenialReasonsPopup(dispatch, false);
    });
  };
  const nonWarningFields = {
    dueAfter: null,
    assignedToUserId: null,
    dueInterval: null,
    selectedAuditGroupIds: null,
    assignedToUserTypeValue: null,
    isDenialReasonsAssignedToExternalUser: null,
  };
  const getDenialReasonsFormDataForCompare = () => {
    return {
      ...denialReasonsFormData,
      ...nonWarningFields,
    };
  };
  const getInitialDenialReasonsFormDataForCompare = () => {
    return {
      ...initialDenialReasonsFormData,
      ...nonWarningFields,
    };
  };
  const isChangesOnDenialReasonsLinkedAuditWarningApplicable = (): boolean => {
    return (
      !isEqual(
        getDenialReasonsFormDataForCompare(),
        getInitialDenialReasonsFormDataForCompare()
      ) &&
      denialReasonsPopupMode === DENIAL_REASONS_POPUP_MODE.EDIT &&
      denialReasonsLinkedData.denialReasonAttachedAudit &&
      denialReasonsLinkedData.denialReasonAttachedAudit.length > 0
    );
  };
  const isCannotChnageAuditGroupsForDenialReasonLinkedToAuditWarningApplicable = (): boolean => {
    return (
      denialReasonsPopupMode === DENIAL_REASONS_POPUP_MODE.EDIT &&
      denialReasonAffectingFieldsChangeTrackerObject["auditGroup"] &&
      denialReasonsLinkedData.denialReasonAttachedAudit &&
      denialReasonsLinkedData.denialReasonAttachedAudit.length > 0
    );
  };
  const isChangesOnExistingDenialReasonWarningApplicable = (): boolean => {
    return (
      !isEqual(
        getDenialReasonsFormDataForCompare(),
        getInitialDenialReasonsFormDataForCompare()
      ) &&
      denialReasonsPopupMode === DENIAL_REASONS_POPUP_MODE.EDIT &&
      denialReasonsLinkedData.denialReasonAttachedAudit &&
      denialReasonsLinkedData.denialReasonAttachedAudit.length > 0
    );
  };
  const validateAndSaveDenialReasonsData = (
    params,
    isCloseDenialReasonsPopup
  ) => {
    let result = null;
    if (params.validationGroup) result = params.validationGroup.validate();
    if (result && result.isValid) {
      saveDenialReasonsData(isCloseDenialReasonsPopup);
    }
  };
  const getDenialReasonsPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleDenialReasonsPopup(dispatch, false);
        }}
      ></MdaePopupTitle>
    );
  };
  return (
    <div>     
      <MdaePopup
        deferRendering={true}
        height={610}
        maxWidth={1100}
        id={"pnlAddDenialReasonsPopup"}
        onShowing={() => {
          dispatch({
            type: SET_DENIAL_REASON_AFFECTING_FIELDS_CHANGE_OBJECT,
            data: { denialReasonAffectingFieldsChangeTrackerObject: {} },
          });
        }}
        mdaeTitleRender={getDenialReasonsPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_ADD_DENIAL_REASONS_POPUP,
            reducerName: "denialReasons",
            widgetOptionBindings: {
              visible: "isAddDenialReasonsPopupVisible",
              mdaePopupTitle: "denialReasonsPopupTitle",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div
                  className={
                    "create-denial-reasons-container" +
                    (denialReasonsPermissions.hasUpdateAccess
                      ? ""
                      : " mdae-readonly-content")
                  }
                >
                  <div className={"left-container"}>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeTextBox
                        id={"txtDenialReasonsName"}
                        mdaeTextBoxTitle={"Denial Reason Name"}
                        required={true}
                        maxLength={200}
                        disabled={denialReasonsFormData.curatedInd}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: SET_DENIAL_REASONS_FORM_DATA,
                            reducerName: "denialReasons",
                            widgetOptionBindings: {
                              value: "denialReasonsFormData.denialReasonName",
                            },
                          },
                          {
                            actionType: RESET_DENIAL_REASONS_POPUP_VALIDATION,
                            reducerName: "denialReasons",
                            widgetOptionBindings: {
                              isValid: "isDenialReasonsFormDataValid",
                            },
                          },
                        ]}
                      >
                        <Validator
                          validationGroup={denialReasonsValidationGroup}
                        >
                          <RequiredRule message="Please enter name." />
                        </Validator>
                      </MdaeTextBox>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeTextBox
                        id={"txtDenialReasonsDisplayAlias"}
                        maxLength={200}
                        mdaeTextBoxTitle={"Display Name"}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: SET_DENIAL_REASONS_FORM_DATA,
                            reducerName: "denialReasons",
                            widgetOptionBindings: {
                              value: "denialReasonsFormData.displayName",
                            },
                          },
                        ]}
                      ></MdaeTextBox>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeTextArea
                        id="txtDescription"
                        mdaeTextAreaTitle="Description"
                        height={99}
                        maxLength={500}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: SET_DENIAL_REASONS_FORM_DATA,
                            reducerName: "denialReasons",
                            widgetOptionBindings: {
                              value: "denialReasonsFormData.description",
                            },
                          },
                        ]}
                      />
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeSelectBox
                        id={"ddlTaskCategory"}
                        mdaeDropDownBoxTitle={"Category"}
                        displayExpr={(item) =>
                          item?.displayAlias?.trim()
                            ? item?.displayAlias
                            : item?.categoryName
                        }
                        valueExpr={"categoryId"}
                        disabled={denialReasonsFormData.curatedInd}
                        required={true}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: GET_DENIAL_REASONS_REFERENCE_DATA,
                            reducerName: "denialReasons",
                            isAsyncComplete: true,
                            widgetOptionBindings: {
                              dataSource: "activeCategoryList",
                            },
                          },
                          {
                            actionType: SET_DENIAL_REASONS_FORM_DATA,
                            reducerName: "denialReasons",
                            widgetOptionBindings: {
                              value: "denialReasonsFormData.categoryId",
                            },
                          },
                          {
                            actionType: RESET_DENIAL_REASONS_POPUP_VALIDATION,
                            reducerName: "denialReasons",
                            widgetOptionBindings: {
                              isValid: "isDenialReasonsFormDataValid",
                            },
                          },
                        ]}
                      >
                        <Validator
                          validationGroup={denialReasonsValidationGroup}
                        >
                          <RequiredRule message="Please select category." />
                        </Validator>
                      </MdaeSelectBox>
                    </div>
                    <div
                      className={"widget-separation-margin-top"}
                      id={"pnlAuditGroupContainer"}
                    >
                      <MdaeTagBox
                        id={"pnlAuditGroup"}
                        name="auditGroup"
                        isAuditGroupWidget={true}
                        isPageEditMode={
                          denialReasonsPopupMode ===
                          DENIAL_REASONS_POPUP_MODE.EDIT
                        }
                        auditGroupEntityName="Denial Reason"
                        readOnlyTooltipContainerId={"pnlAuditGroupContainer"}
                        hasAllAuditGroupAccess={hasAllAuditGroupAccess}
                        required                                     
                        mdaeTagBoxTitle={"Assign to Audit Groups"}
                        displayExpr={"name"}
                        valueExpr={"auditGroupId"}
                        showSelectionControls={true}
                        maxDisplayedTags={1}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: GET_DENIAL_REASONS_AUDIT_GROUP_LIST,
                            isAsyncComplete: true,
                            widgetOptionBindings: {
                              dataSource: "list",
                            },
                          },
                          {
                          actionType: SET_DENIAL_REASONS_FORM_DATA,
                          reducerName: "denialReasons",
                          widgetOptionBindings: {
                            value: "denialReasonsFormData.selectedAuditGroupIds",
                          },
                        },                         
                        ]}
                      >
                        <Validator
                          validationGroup={denialReasonsValidationGroup}
                        >
                          <RequiredRule message="Please select atleast one audit group." />
                        </Validator>
                      </MdaeTagBox>
                    </div>
                  </div>
                  <div className={"right-container"}>
                    <div className={"denial-reason-options-container"}>
                      <div className={"mdae-data-field-label"}>
                      </div>
                      <div className={"top-margin"}>
                        <MdaeTagBox
                          id={"ddlOrganizationName"}
                          showSelectionControls={true}
                          maxDisplayedTags={1}
                          mdaeTagBoxTitle={"Associated Requesters"}
                          displayExpr={"organizationName"}
                          valueExpr={"eaRequesterId"}
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: GET_DENIAL_REASONS_REFERENCE_DATA,
                              reducerName: "denialReasons",
                              isAsyncComplete: true,
                              widgetOptionBindings: {
                                dataSource: "requesterList",
                              },
                            },
                            {
                              actionType: SET_DENIAL_REASONS_FORM_DATA,
                              reducerName: "denialReasons",
                              widgetOptionBindings: {
                                value: "denialReasonsFormData.eaRequesterId",
                              },
                            },
                          ]}
                        ></MdaeTagBox>
                      </div>
                    </div>
                    
                    <div className={"widget-separation-margin-top"}>
                      <div className={"curated-container"}>
                        <div className={"mdae-data-field-label"}>
                          Curated :
                        </div>
                        <div className={"mdae-data-field-content"}>
                          {denialReasonsFormData.curatedInd ? " Yes" : " No"}
                        </div>
                      </div>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <div className={"denial-reasons-dates-container"}>
                        <div className={"effective-date-container"}>
                          <MdaeDateBox
                            id="dtEffectiveDate"
                            required
                            disabled={
                              (differenceInCalendarDays(
                                denialReasonsFormData.effectiveDate,
                                new Date()
                              ) <= 0 &&
                                denialReasonsPopupMode ===
                                  DENIAL_REASONS_POPUP_MODE.EDIT) ||
                              denialReasonsFormData.curatedInd
                            }
                            min={getEffectiveDateMinValue(
                              denialReasonsFormData.effectiveDate
                            )}
                            mdaeDateBoxTitle="Effective Date"
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_DENIAL_REASONS_FORM_DATA,
                                reducerName: "denialReasons",
                                widgetOptionBindings: {
                                  value: "denialReasonsFormData.effectiveDate",
                                },
                              },
                              {
                                actionType: RESET_DENIAL_REASONS_POPUP_VALIDATION,
                                reducerName: "denialReasons",
                                widgetOptionBindings: {
                                  isValid: "isDenialReasonsFormDataValid",
                                },
                              },
                            ]}
                          >
                            <Validator
                              validationGroup={denialReasonsValidationGroup}
                            >
                              <RequiredRule message="Please enter an effective date." />
                            </Validator>
                          </MdaeDateBox>
                        </div>
                        <div className={"term-date-container"}>
                          <MdaeDateBox
                            id="dtpTermDate"
                            mdaeDateBoxTitle="Term Date"
                            min={getTermDateMinValue(
                              denialReasonsFormData.effectiveDate
                            )}
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_DENIAL_REASONS_FORM_DATA,
                                reducerName: "denialReasons",
                                widgetOptionBindings: {
                                  value: "denialReasonsFormData.termDate",
                                },
                              },
                            ]}
                          ></MdaeDateBox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"widget-separation-margin-top"}>
                  {DENIAL_REASONS_POPUP_MODE.EDIT == denialReasonsPopupMode && (
                    <>
                      <div className={"denial-reasons-updation-details"}>
                        <div className={"created-by-container"}>
                          <div className={"mdae-data-field-label created-by-label"}>
                            Created By:
                          </div>
                          <div
                            className={
                              "mdae-data-field-content value text-overflow-ellipsis"
                            }
                            title={denialReasonsFormData.createdBy}
                          >
                            {denialReasonsFormData.createdBy}
                          </div>
                        </div>
                        <div className={"create-date-container"}>
                          <div className={"mdae-data-field-label create-date-label"}>
                            Created On:
                          </div>
                          <div
                            className={
                              "mdae-data-field-content value text-overflow-ellipsis"
                            }
                          >
                            {denialReasonsFormData.createDate
                              ? format(
                                  new Date(denialReasonsFormData.createDate),
                                  "MM/DD/YYYY"
                                )
                              : ""}
                          </div>
                        </div>

                        <div className={"updated-by-container"}>
                          <div className={"mdae-data-field-label updated-by-label"}>
                            Last Updated By:
                          </div>
                          <div
                            className={
                              "mdae-data-field-content value text-overflow-ellipsis"
                            }
                            title={denialReasonsFormData.updatedBy}
                          >
                            {denialReasonsFormData.updatedBy}
                          </div>
                        </div>
                        <div className={"update-date-container"}>
                          <div className={"mdae-data-field-label update-date-label"}>
                            Last Updated On:
                          </div>
                          <div
                            className={
                              "mdae-data-field-content value text-overflow-ellipsis"
                            }
                          >
                            {denialReasonsFormData.updateDate
                              ? format(
                                  new Date(denialReasonsFormData.updateDate),
                                  "MM/DD/YYYY"
                                )
                              : ""}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </MdaePopupContent>
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"btnCancelDenialReasons"}
                  role={"secondary"}
                  onClick={() => {
                    toggleDenialReasonsPopup(dispatch, false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                {denialReasonsPermissions.hasUpdateAccess && (
                  <>
                    <div style={{ marginRight: "10px" }}>
                      <MdaeButton
                        id={"btnSaveDenialReasons"}
                        visible={!props.isHideSaveButton}
                        validationGroup={denialReasonsValidationGroup}
                        onClick={(params) => {
                          validateAndSaveDenialReasonsData(params, false);
                        }}
                        role={"primary"}
                      >
                        Save
                      </MdaeButton>
                    </div>
                    <div>
                      <MdaeButton
                        id={"btnSaveAndCloseDenialReasons"}
                        validationGroup={denialReasonsValidationGroup}
                        onClick={(params) => {
                          validateAndSaveDenialReasonsData(params, true);
                        }}
                        role={"primary"}
                      >
                        Save and Close
                      </MdaeButton>
                    </div>
                  </>
                )}
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
    </div>
  );
};

const getEffectiveDateMinValue = (effectiveDate) => {
  if (effectiveDate) {
    const isSmallerThanToday = compareAsc(effectiveDate, new Date());
    if (isSmallerThanToday === -1) {
      return effectiveDate;
    }
  }
  return new Date(new Date().toDateString());
};

const getTermDateMinValue = (effectiveDate) => {
  if (effectiveDate) {
    const date = new Date(effectiveDate);
    const isSmallerThanToday = compareAsc(date, new Date());
    if (isSmallerThanToday === -1) {
      return new Date(new Date().toDateString());
    } else return date;
  }
  return new Date(new Date().toDateString());
};

const areArrayItemsEqual = (arrayOne, arrayTwo): boolean => {
  return (
    arrayOne.length === arrayTwo.length &&
    arrayOne.every((item) => arrayTwo.includes(item))
  );
};

export default AddDenialReasonsPopup;
